import { useState, useRef } from "react";
import campaignSortIcon from '../assets/images/svg/campaign-sort-icon.svg';

export const SORT_OPTIONS = [
  "Create Date: New to Old",
  "Create Date: Old to New",
  "Highest Clicks",
  "Highest CTR",
];

interface SortSelectorProps {
  selectedSort?: string;
  onSortChange?: (sortOption: string) => void;
  sortOptions?: string[];
}

export default function SortSelector({ selectedSort, onSortChange, sortOptions = SORT_OPTIONS }: SortSelectorProps) {
  const [internalSelected, setInternalSelected] = useState(sortOptions[0]);
  const [open, setOpen] = useState(false);

  // Use external prop if provided, otherwise use internal state
  const selected = selectedSort ?? internalSelected;

  const handleSortChange = (option: string) => {
    if (onSortChange) {
      onSortChange(option);
    } else {
      setInternalSelected(option);
    }
    setOpen(false);
  };

  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="relative">
      {/* Trigger - Same styling as existing button */}
      <button
        ref={buttonRef}
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 sm:px-4 py-3 rounded-lg text-[#4B4F55] font-[500] leading-[130%] tracking-[0] font-[style:'Medium'] text-[16px] sm:text-[18px] transition-opacity"
      >
        <span className="whitespace-nowrap">Sort</span>
        <img src={campaignSortIcon} alt="Sort" className="w-[22px] h-[16px] flex-shrink-0" />
      </button>

      {/* Dropdown */}
      {open && (
        <div
          className="absolute mt-2 right-0 overflow-hidden z-50 flex flex-col"
          style={{
            width: '280px',
            maxWidth: 'calc(100vw - 32px)',
            borderRadius: '16px',
            borderWidth: '1px',
            borderColor: '#82879833',
            borderStyle: 'solid',
            paddingTop: '24px',
            paddingRight: '24px',
            paddingBottom: '24px',
            paddingLeft: '24px',
            gap: '3px',
            backgroundColor: '#1A1B1F'
          }}
        >
          {sortOptions.map((option, index) => {
            const isSelected = option === selected;

            return (
              <button
                key={index}
                disabled={isSelected}
                onClick={() => handleSortChange(option)}
                className={`w-full text-left py-3
                  ${isSelected
                    ? "text-[#58F2A9] cursor-not-allowed  text-[14px] font-[400]"
                    : "text-white text-[14px] font-[400]"
                  }`}
                style={index !== sortOptions.length - 1 ? { borderBottom: '1px solid rgba(255,255,255,0.1)' } : {}}
              >
                {option}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
